import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  async copy(event) {
    const root = event.currentTarget;
    const label = root.querySelector("[data-copy-label]") || root;
    const original = label.dataset.originalText || label.textContent.trim();
    label.dataset.originalText = original;

    try {
      await navigator.clipboard.writeText(window.location.href);
      label.textContent = "已复制链接";
      setTimeout(() => {
        label.textContent = original;
      }, 2000);
    } catch {
      // ponytail: clipboard may fail on insecure contexts
    }
  }
}
